import { formatDateTime } from "../graphView/formatters";

function parseWQNumber(detail, key) {
  const v = detail[key];
  if (v === null || v === undefined || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/**
 * Build rows for PondStat water-quality charts: one row per pond detail session.
 * @param {Array<object>} pondDetails - enriched sessions (Date + WQ fields)
 */
export function buildWQDetailRows(pondDetails) {
  if (!Array.isArray(pondDetails)) return [];
  return [...pondDetails]
    .map((d) => ({
      detail: d,
      dateLabel: formatDateTime(d.Date),
      dateMs: new Date(d.Date).getTime(),
      WaterTemperature: parseWQNumber(d, "WaterTemperature"),
      DO: parseWQNumber(d, "DO"),
      BOD5: parseWQNumber(d, "BOD5"),
      COD: parseWQNumber(d, "COD"),
      TotalHardness: parseWQNumber(d, "TotalHardness"),
      Alkalinity: parseWQNumber(d, "Alkalinity"),
      NitriteN: parseWQNumber(d, "NitriteN"),
      TotalAmmoniaNitrogen: parseWQNumber(d, "TotalAmmoniaNitrogen"),
      PhosphateIon: parseWQNumber(d, "PhosphateIon"),
      Phosphorous: parseWQNumber(d, "Phosphorous"),
    }))
    .filter((r) => !Number.isNaN(r.dateMs))
    .sort((a, b) => a.dateMs - b.dateMs);
}
